import { OrgSettings } from "~/entities/baseEntities";
import { Currency } from "~/entities/currencyEntities";

export const formatNum = (
  src: string | number | null | undefined,
  digits: number | null = 2
): string | null | undefined => {
  return src == null
    ? src
    : Number(src).toLocaleString(
        undefined,
        digits == null
          ? undefined
          : {
              minimumFractionDigits: digits,
              maximumFractionDigits: digits,
            }
      );
};

export const formatPercent = (
  src: string | number | null | undefined,
  digits: number = 2,
  plusIfPos: boolean = false
): string | null | undefined =>
  src == null
    ? src
    : (plusIfPos && Number(src) >= 0 ? "+" : "") + formatNum(src, digits) + "%";

export const formatCurrency = (
  src: string | number | null | undefined,
  digits: number = 2,
  currencySymbol: string = "$"
): string | null | undefined =>
  src == null
    ? src
    : (Number(src) < 0 ? "-" : "") +
      currencySymbol +
      formatNum(Math.abs(Number(src)), digits);

export const formatIntCurrency = (
  src: string | number | null | undefined,
  currency: Currency
): string | null | undefined =>
  src == null
    ? src
    : formatCurrency(
        Number(src) / Math.pow(10, currency.currencyPrecision),
        currency.currencyPrecision,
        currency.currencySymbol
      );

export const formatLoyaltyBalance = (
  orgSettings: OrgSettings,
  loyaltyBalance: number = 0
) =>
  orgSettings?.loyaltySettings?.balanceIsMonetary
    ? (loyaltyBalance / 100).toFixed(2)
    : formatNum(loyaltyBalance, 0);
